import { Slider, Stack, Typography } from '@mui/material'
import { SyntheticEvent } from 'react'
import { IconButton } from 'utoniq-ui'

import { styles } from '@/components/styles'

export const VideoPlayerControl = ({
  isPlaying,
  duration,
  sliderValue,
  onPlay,
  onPause,
  onRewind,
  onForward,
  onChange,
  onChangeCommitted,
}: {
  isPlaying: boolean
  duration: number
  sliderValue: number
  onPlay: () => void
  onPause: () => void
  onRewind: () => void
  onForward: () => void
  onChange: (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => void
  onChangeCommitted: (
    event: Event | SyntheticEvent<Element, Event>,
    value: number | number[]
  ) => void
}) => (
  <Stack
    sx={{
      position: 'absolute',
      zIndex: 10,
      bottom: 20,
      left: 20,
      right: 20,
      bgcolor: 'rgba(18,18,18,0.6)',
      py: 2,
      pr: 6,
      pl: 4,
      borderRadius: 2,
      mb: styles.safeAreaBottom,
    }}
    direction="row"
    flex={1}
    alignItems="center"
    spacing={4}
  >
    <Stack>
      <Stack spacing={2} direction="row">
        <IconButton.VideoRewind onClick={onRewind} />
        {isPlaying ? (
          <IconButton.VideoPause onClick={onPause} />
        ) : (
          <IconButton.VideoPlay onClick={onPlay} />
        )}
        <IconButton.VideoForward onClick={onForward} />
      </Stack>
    </Stack>
    <Stack flex={1}>
      <Slider
        min={0}
        max={duration}
        defaultValue={0}
        value={sliderValue}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        sx={{ '&.MuiSlider-root': { py: 2 } }}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ '& > span': { color: '#F1F5F6' } }}
      >
        <Typography variant="caption">{secondToMmss(sliderValue)}</Typography>
        <Typography variant="caption">
          {Number.isFinite(duration) &&
            secondToMmss(Math.floor(duration) - Math.floor(sliderValue))}
        </Typography>
      </Stack>
    </Stack>
  </Stack>
)

const secondToMmss = (second: number) =>
  [Math.floor(second / 60), Math.floor(second % 60)]
    .map(timeNum => String(timeNum).padStart(2, '0'))
    .join(':')
